import EfTitle from '@elem/ui/ef-title';
import EfSpec from '@elem/ui/ef-spec';
import EfLink from '@elem/ui/ef-link';
import EfImg from '@elem/ui/ef-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('Oasis.Developer');
    const { locale } = useRouter();
    const IS_NA_SITES = ['us', 'ca'].includes(locale ?? '');
    return (
        <div className={`${styles.TheComp}`} id="Developer">
            <EfSpec />
            <EfTitle theme="white">{t('title')}</EfTitle>
            <div className="container">
                <div className="box-title">{t('desc')}</div>
                <EfLink
                    className="box-btn"
                    href={IS_NA_SITES ? 'https://developer.ecoflow.com' : 'https://developer-eu.ecoflow.com/'}
                    dataLayer={
                        IS_NA_SITES
                            ? null
                            : {
                                  event: 'uaEvent',
                                  event_name: 'jump_button',
                                  position: 'Inpage',
                                  button_name: t('btn'),
                                  url: 'https://developer-eu.ecoflow.com/us',
                              }
                    }
                >
                    {t('btn')}
                </EfLink>

                <EfImg
                    className="developer-background"
                    pc={
                        IS_NA_SITES
                            ? 'https://websiteoss.ecoflow.com/upload/image/1735787929220/paltform.jpg'
                            : 'https://websiteoss.ecoflow.com/upload/image/1744093794955/pc_Developer%20Platform%20(1).png'
                    }
                    h5={
                        IS_NA_SITES
                            ? 'https://websiteoss.ecoflow.com/upload/image/1735787929050/platform_M.jpg'
                            : 'https://websiteoss.ecoflow.com/upload/image/1744879453785/m_Developer%20Platform%20(1).png'
                    }
                />
            </div>
        </div>
    );
}
